import { render, staticRenderFns } from "./MessageDetailView.vue?vue&type=template&id=8790dfa6&scoped=true&"
import script from "./MessageDetailView.vue?vue&type=script&lang=js&"
export * from "./MessageDetailView.vue?vue&type=script&lang=js&"
import style0 from "../../assets/css/all-admin.css?vue&type=style&index=0&id=8790dfa6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8790dfa6",
  null
  
)

export default component.exports